import React from "react";

interface HeadlineBoxProps {
  headline?: string;
}
const HeadlineBox: React.FC<HeadlineBoxProps> = ({ headline }) => {
  const text = headline ?? "Enhance your order today";
  return (
    <>
      <div className="my-4 flex justify-center">
        <span className="text-xl text-center font-bold">{text}</span>
      </div>
    </>
  );
};

export default HeadlineBox;
